import { render, staticRenderFns } from "./course_admin.vue?vue&type=template&id=703159ea&scoped=true&"
import script from "./course_admin.vue?vue&type=script&lang=ts&"
export * from "./course_admin.vue?vue&type=script&lang=ts&"
import style0 from "./course_admin.vue?vue&type=style&index=0&id=703159ea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703159ea",
  null
  
)

export default component.exports